// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file reaction/reaction_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file reaction/reaction_requests.proto.
 */
export const file_reaction_reaction_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiByZWFjdGlvbi9yZWFjdGlvbl9yZXF1ZXN0cy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiGQoXR2V0VXNlclJlYWN0aW9uc1JlcXVlc3RCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.GetUserReactionsRequest
 */
export type GetUserReactionsRequest = Message<'com.gem.bff.contract.GetUserReactionsRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetUserReactionsRequest.
 * Use `create(GetUserReactionsRequestSchema)` to create a new message.
 */
export const GetUserReactionsRequestSchema: GenMessage<GetUserReactionsRequest> =
  /*@__PURE__*/
  messageDesc(file_reaction_reaction_requests, 0);
